module.exports = __webpack_public_path__ + "img/p3_l.77577cc1.jpg";